import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, Subject } from 'rxjs';
import { IFacility } from './facility';
import { ReusableService } from 'src/app/services/reusable.service';
import { ApiEndpoint, IPagingResponse } from 'src/app/core/http/api';

@Injectable({
  providedIn: 'root',
})
export class FacilityService {
  constructor(private _reusableService: ReusableService) {}

  private _selectedFacility = new BehaviorSubject<IFacility | null | undefined>(null);
  selectedFacility$ = this._selectedFacility.asObservable();
  set selectedFacility(val: IFacility | null | undefined) {
    this._selectedFacility.next(val);
  }

  private _facilities = new BehaviorSubject<IFacility[]>([]);
  facilities$ = this._facilities.asObservable();
  set facilities(val: IFacility[]) {
    this._facilities.next(val);
  }

  private _facilitiesToDisplay = new BehaviorSubject<IFacility[]>([]);
  facilitiesToDisplay$ = this._facilitiesToDisplay.asObservable();
  set facilitiesToDisplay(val: IFacility[]) {
    this._facilitiesToDisplay.next(val);
  }

  refresh$ = new Subject<boolean>();

  private _unsubscribeAll = new Subject();

  ngOnDestroy() {
    this._unsubscribeAll.next(true);
    this._unsubscribeAll.complete();
  }

  getList(): Observable<IFacility[]> {
    const params = {
      filterOptions: {
        pageIndex: 1,
        pageSize: 200,
      },
      search: '',
      isActive: true,
    };
    return this._reusableService.get(ApiEndpoint.GetListFacilities, params).pipe(
      map((res: IPagingResponse<IFacility>) => {
        const data = res.result.data;
        this.facilities = [...data];
        return data;
      }),
    );
  }
}
